export const ValidatorMessages = {
  email: 'VALIDATOR_EMAIL',
  required: 'VALIDATOR_REQUIRED',
  hasNumber: 'VALIDATOR_PATTERN_NUMBER',
  hasSpace: 'VALIDATOR_PATTERN_SPACE',
  hasCapitalCase: 'VALIDATOR_PATTERN_CAPITAL_CASE',
  hasSmallCase: 'VALIDATOR_PATTERN_SMALL_CASE',
  hasSpecialCharacters: 'VALIDATOR_PATTERN_SPECIAL',
  minlength: 'VALIDATOR_MIN_LENGTH_8',
  maxlength: 'VALIDATOR_MAX_LENGTH_20',
  hasUnacceptableSymbols: 'VALIDATOR_PATTERN_LATIN',
  hasMatch: 'VALIDATOR_PASSWORD_INCORRECT',
};
